import { render, staticRenderFns } from "./DeveloperPage.vue?vue&type=template&id=1f3317da&lang=pug"
import script from "./DeveloperPage.vue?vue&type=script&lang=js"
export * from "./DeveloperPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports